// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectInterestsOnBalancePlanMessage, InterestsOnBalancePlanEntryBean } from '@shared/utils/DirectMessages/DirectInterestsOnBalancePlanMessage';
export class InterestsOnBalancePlanMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        var _a;
        const message = new DirectInterestsOnBalancePlanMessage();
        message.InterestsOnBalancePlanID = fieldSet.GetValue(FieldsFactory.FIELD_INTERESTS_ON_BALANCE_PLAN_ID);
        message.CounterAccountID = fieldSet.GetValue(FieldsFactory.FIELD_COUNTER_ACCOUNT_ID);
        message.Description = fieldSet.GetValue(FieldsFactory.FIELD_DESCRIPTION);
        message.Name = fieldSet.GetValue(FieldsFactory.FIELD_NAME);
        const groups = (_a = fieldSet.GetGroups(FieldsFactory.INTEREST_ON_BALANCE_PLAN_ENTRY_GROUP)) !== null && _a !== void 0 ? _a : [];
        message.ListInterestsOnBalancePlanEntryBean = groups.map((group) => {
            const entry = new InterestsOnBalancePlanEntryBean();
            entry.AssetID = group.GetValue(FieldsFactory.FIELD_ASSET_ID);
            entry.Interest = group.GetValue(FieldsFactory.FIELD_INTEREST);
            entry.NegativeInterest = group.GetValue(FieldsFactory.FIELD_INTEREST_NEGATIVE);
            return entry;
        });
        return [message];
    }
}
